import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import "../login/styles.css";
import { useTranslation } from "react-i18next";
import { GetProps, Input } from "antd";
import axios from "axios";

type OTPProps = GetProps<typeof Input.OTP>;

const EnterCode = () => {
  const { t } = useTranslation();
  const [minutes, setMinutes] = useState(1);
  const [seconds, setSeconds] = useState(59);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }

      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
        } else {
          setSeconds(59);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds]);
  const email = localStorage.getItem("email");

  const onChange: OTPProps["onChange"] = async (data) => {
    const sendData = JSON.stringify({ code: data });

    const res = await axios.post(
      "http://api.udrc.uz/api/users/send_code",
      sendData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (res.status === 200) {
      localStorage.setItem("resetToken", res.data.resetToken);
      navigate("/forgot_password");
    } else {
    }
  };

  const getNewCode = async(e:any) => {
    e.preventDefault()
    setMinutes(1)
    setSeconds(59)
    const sendData = JSON.stringify({ email: email });
    console.log(sendData)

    const res = await axios.post(
      "http://api.udrc.uz/api/users/send_email",
      sendData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (res.status === 204) {
        navigate("/enter_code")
    }
  }

  const sharedProps: OTPProps = {
    onChange,
  };

  const active_lang = localStorage.getItem("i18lang");
  return (
    <div className="login_page bg-main_color min-h-screen text-white w-full lg:px-20 sm:px-10 px-5">
      <div className="max-w-[1681px] mx-auto">
        <div className="flex items-center h-screen justify-center">
          <div className="w-[500px] max-sm:w-full px-5">
            <h2 className="text-[40px] mb-3 font-bold text-center">Enter your code!</h2>
            <form  className="w-full flex flex-col items-center">
              <Input.OTP className="font-bold" {...sharedProps} />
              <div className="flex gap-2 text-xl justify-center mt-4">
                <p>{minutes >= 10 ? minutes : `0${minutes}`}</p>:
                <p>{seconds >= 10 ? seconds : `0${seconds}`}</p>
              </div>
              <button className="text-xl underline" onClick={getNewCode}>get new code</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnterCode;
